'use client'

import { Container, Grid, Typography } from '@mui/material'

import { BreadcrumbsCustom } from '@/components/BreadcrumbsCustom/BreadcrumbsCustom'
import { SanityComponent } from '@/components/SanityComponent/SanityComponent'
import { getPageFromSanityPages } from '@/helpers/getPageFromSanityPages'
import { useSiteContext } from '@/hooks/useSiteContext'
import { useTranslations } from '@/hooks/useTranslations'
import { commerceTheme as theme } from '@/themes/commerce/theme'

import type { UnpackedSanityPage } from '@/lib/queries/sanityQueryStrings'

type ContentPageClientProps = {
  sanityPages: UnpackedSanityPage[]
}

export default function ContentPageClient({ sanityPages }: ContentPageClientProps) {
  const { language, translate } = useTranslations()
  const { siteContext } = useSiteContext()

  const page = getPageFromSanityPages(sanityPages, siteContext, language)
  const content = page?.content

  return (
    <>
      {content ? (
        <main className="flex-1">
          <Container disableGutters sx={{ pt: 4, pb: 3 }}>
            <Container sx={{ backgroundColor: theme.palette.background.light }}>
              <Grid
                container
                spacing={3}
                pb={2}
                px={{
                  xs: 2,
                  lg: 0,
                }}
                justifyContent="center"
              >
                <Container sx={{ py: 1 }}>
                  <BreadcrumbsCustom title={page?.title} />
                </Container>
                {content &&
                  content
                    .filter((item) => !!item._type)
                    .map((item) => (
                      <Grid
                        item
                        xs={12}
                        pr={{
                          xs: 0,
                          lg: 3,
                        }}
                        key={item._id}
                      >
                        <SanityComponent sanityComponent={item} />
                      </Grid>
                    ))}
              </Grid>
            </Container>
          </Container>
        </main>
      ) : (
        <main className="flex-1">
          <Container sx={{ my: 4 }}>
            <Typography variant="h1">{translate('page.404.title')}</Typography>
          </Container>
        </main>
      )}
    </>
  )
}
